// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/place_types/automotive.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/place_types/automotive.proto.
 */
export const file_proto_model_core_place_types_automotive = /*@__PURE__*/
  fileDesc("Ci1wcm90by9tb2RlbC9jb3JlL3BsYWNlX3R5cGVzL2F1dG9tb3RpdmUucHJvdG8SBmNhcm1lbir+AgoTQXV0b21vdGl2ZVBsYWNlVHlwZRIlCiFBVVRPTU9USVZFX1BMQUNFX1RZUEVfVU5TUEVDSUZJRUQQABIkCiBBVVRPTU9USVZFX1BMQUNFX1RZUEVfQ0FSX0RFQUxFUhABEiQKIEFVVE9NT1RJVkVfUExBQ0VfVFlQRV9DQVJfUkVOVEFMEAISJAogQVVUT01PVElWRV9QTEFDRV9UWVBFX0NBUl9SRVBBSVIQAxIiCh5BVVRPTU9USVZFX1BMQUNFX1RZUEVfQ0FSX1dBU0gQBBI7CjdBVVRPTU9USVZFX1BMQUNFX1RZUEVfRUxFQ1RSSUNfVkVISUNMRV9DSEFSR0lOR19TVEFUSU9OEAUSJQohQVVUT01PVElWRV9QTEFDRV9UWVBFX0dBU19TVEFUSU9OEAYSIQodQVVUT01PVElWRV9QTEFDRV9UWVBFX1BBUktJTkcQBxIjCh9BVVRPTU9USVZFX1BMQUNFX1RZUEVfUkVTVF9TVE9QEAhCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw");

/**
 * Describes the enum carmen.AutomotivePlaceType.
 */
export const AutomotivePlaceTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_place_types_automotive, 0);

/**
 * Automotive-related place types
 *
 * @generated from enum carmen.AutomotivePlaceType
 */
export const AutomotivePlaceType = /*@__PURE__*/
  tsEnum(AutomotivePlaceTypeSchema);

